import { withLogger } from '@kit/logger';
import type { Logger } from '@kit/logger';

import { MonitoringService } from './monitoring.service';

export class ConsoleMonitoringService implements MonitoringService {
  identifyUser(data: { id: string }) {
    withLogger((logger: Logger) =>
      logger.info(
        {
          service: 'console-monitoring',
          function: 'identifyUser',
          userId: data.id,
        },
        'Identified user',
      ),
    );
  }

  captureException(error: Error) {
    withLogger((logger: Logger) =>
      logger.error(
        {
          service: 'console-monitoring',
          function: 'captureException',
          error: error.message,
          stack: error.stack,
        },
        'Caught exception',
      ),
    );
  }

  captureEvent(event: string) {
    withLogger((logger: Logger) =>
      logger.info(
        {
          service: 'console-monitoring',
          function: 'captureEvent',
          event,
        },
        `Captured event: ${event}`,
      ),
    );
  }

  ready() {
    return Promise.resolve();
  }
}
